import cx from "classnames";
import React from "react";
import { Select } from "components/Select/Select";
import { useTranslate } from "hooks";
import { SelectedAccessoryDetails } from "./SelectedAccessoryDetails";
import type { SelectedAccessory, AccessoryGroup } from "stores/product";
import { WITHOUT_ACCESSORY_VALUE } from "variables";

type ProductAccessoriesModalPartProps = {
  onSelectionChange: (value: string) => void;
  accessoryGroup: AccessoryGroup | null;
  selectedAccessories: SelectedAccessory[];
};

export const ProductAccessoriesModalPart = ({
  onSelectionChange,
  accessoryGroup,
  selectedAccessories,
}: ProductAccessoriesModalPartProps) => {
  const translate = useTranslate();

  const selectedAccessory = selectedAccessories.find(
    (accessory) => accessory?.accessoryGroupId === accessoryGroup?.id,
  );

  const accessoryOptions = accessoryGroup?.accessories?.map((accessory) => ({
    label:
      accessory?.seriesId === 0
        ? translate.stringOnly("PRODUCT_CONFIGURATOR_WITHOUT")
        : (accessory?.currentPresentation ?? ""),
    value:
      accessory?.seriesId === 0
        ? WITHOUT_ACCESSORY_VALUE
        : (accessory?.currentPresentation ?? ""),
  }));

  const withoutOption = accessoryOptions?.find(
    (opt) => opt.value === WITHOUT_ACCESSORY_VALUE,
  );

  const selectedOption = selectedAccessory
    ? accessoryOptions?.find((opt) =>
        selectedAccessory.seriesId === 0
          ? opt.value === WITHOUT_ACCESSORY_VALUE
          : opt.value === selectedAccessory.currentPresentation,
      )
    : withoutOption;

  const handleChange = (option: { value: string } | null) => {
    if (!option) {
      console.error("Selected option is nullish");
      return;
    }
    onSelectionChange(option.value);
  };

  if (!accessoryGroup) {
    return <></>;
  }

  return (
    <div
      className={cx(
        "d-flex flex-column flex-grow-1 flex-shrink-2 px-4 py-3 bg-white border rounded-2",
      )}
    >
      <h3 className="text-capitalize">{accessoryGroup.name}</h3>

      <Select
        options={accessoryOptions}
        value={selectedOption}
        isOptionSelected={(option, selectValue) =>
          selectValue.some((v) => v === option)
        }
        onChange={handleChange}
        name="accessorySelect"
        testId={`accessory-select-${accessoryGroup.id}`}
        className="font-md w-100 text-capitalize"
        menuPlacement="auto"
        menuPosition="fixed"
      />

      {selectedAccessory && (
        <SelectedAccessoryDetails selectedAccessory={selectedAccessory} />
      )}
    </div>
  );
};
